import React from 'react';
import { getLocalizedDateTime, getLocalizedString } from '../../localization/LocalizedString';
import './ServiceTable.css';

const IssueListItem = ({ currentLanguage, item, modalButton }) => {
  const {
    description,
    type,
    createdAt,
    serviceSiteNo,
    destination: {
      companyName,
      customer: {
        name: customerName,
      },
      streetAddress,
      city,
    },
  } = item;

  return (
    <tr className="report-table-row_service">
      <td className="report-table-cell_service">{getLocalizedDateTime(new Date(createdAt), currentLanguage)}</td>
      <td className="report-table-cell_service">{getLocalizedString(type, currentLanguage)}</td>
      <td className="report-table-cell_service">{description}</td>
      <td className="report-table-cell_service">{customerName}</td>
      <td className="report-table-cell_service">{companyName}</td>
      <td className="report-table-cell_service">{streetAddress}</td>
      <td className="report-table-cell_service">{city}</td>
      <td className="report-table-cell_service">{serviceSiteNo}</td>
      <td className="report-table-cell_service">{modalButton}</td>
    </tr>
  );
};

export default IssueListItem;



// WEBPACK FOOTER //
// ./src/components/servicereport/IssueListItem.js